import {
  getEnvConfig,
  loadEnvConfig,
} from "@/app/apiConfig/urlConfig/envConfig";
import { initializeApp, type FirebaseApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
  type Messaging,
} from "firebase/messaging";

let app: FirebaseApp | null = null;
let messagingInstance: Messaging | null = null;
let messagingChecked = false;

const getFirebaseApp = async (): Promise<FirebaseApp> => {
  if (app) return app;
  const config = await loadEnvConfig();
  app = initializeApp(config.firebase);
  return app;
};

export const getFcmMessaging = async (): Promise<Messaging | null> => {
  if (typeof window === "undefined") return null;
  if (messagingChecked) return messagingInstance;

  const supported = await isSupported();
  if (!supported) {
    messagingChecked = true;
    return null;
  }

  const firebaseApp = await getFirebaseApp();
  messagingInstance = getMessaging(firebaseApp);
  messagingChecked = true;
  return messagingInstance;
};

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    const messaging = await getFcmMessaging();
    if (!messaging) return null;

    const config = getEnvConfig();
    const swParams = new URLSearchParams(
      config.firebase as unknown as Record<string, string>,
    );

    const registration = await navigator.serviceWorker.register(
      `/firebase-messaging-sw.js?${swParams.toString()}`,
    );
    await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey: config.VITE_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    return token;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const listenForMessages = (callback: (payload: any) => void) => {
  getFcmMessaging().then((messaging) => {
    if (!messaging) return;
    onMessage(messaging, (payload) => {
      callback(payload);
    });
  });
};
